import { CClient, showErrorAlert } from '@common/utils'
import React, { useEffect, useState } from 'react'
import { captureException } from '@sentry/node'
import { SSOConfigProps } from '@lib/types/competitions'
import { FASTCOMMENTS_TENANT_ID } from '@lib/constants/competitions'
import { FastCommentsCommentWidget } from 'fastcomments-react'

type FastCommentsProps = {
  uniqueUrl: string
  /**
   * @description This function is called if the user is not logged in and tries to use fast-comments
   * sdk
   */
  loginCallback: () => void
}
const FastComments = ({ uniqueUrl, loginCallback }: FastCommentsProps) => {
  const [ssoConfig, setSSOConfig] = useState<SSOConfigProps | {}>({})

  useEffect(() => {
    const getSSOConfig = async () => {
      try {
        const fastCommentsConfigResponse = await CClient(
          '/api/v1/fastcomments/config/'
        )
        if (fastCommentsConfigResponse.ok) {
          const fastCommentsConfig = await fastCommentsConfigResponse.json()
          const ssoConfig = fastCommentsConfig.ssoConfig
          ssoConfig.loginCallback = loginCallback
          setSSOConfig(ssoConfig)
        }
      } catch (error) {
        captureException(error)
        showErrorAlert({
          text:
            'There was an issue fetching comments on this page. Please refresh the page and try again or contact support for help with this issue.',
        })
      }
    }
    getSSOConfig()
  }, [])
  return (
    <FastCommentsCommentWidget
      tenantId={FASTCOMMENTS_TENANT_ID}
      sso={ssoConfig}
      urlId={uniqueUrl}
    />
  )
}

export default FastComments
